import * as React from "react";
import type { SvyStepperProps } from "./SvyStepper.interface";
import {
    Container,
    StepperCheckedIcon,
    StepperEllipse,
    StepperLine,
    StepperStep,
    StepperText,
} from "./SvyStepper.style";

export const SvyStepper: React.FunctionComponent<SvyStepperProps> = ({ steps, stepType = "horizontal" }) => (
    <Container data-testid="svy-stepper">
        {steps?.map((step, index) => (
            <StepperStep key={index} stepType={stepType} data-testid="svy-stepper-step">
                <StepperEllipse
                    active={step.active}
                    stepType={stepType}
                    completed={step.completed}
                    data-testid="svy-stepper-ellipse"
                >
                    {step.completed ? <StepperCheckedIcon stepType={stepType} icon={"check-line"} /> : index + 1}
                </StepperEllipse>
                <StepperText active={step.active} stepType={stepType}>
                    {step.label}
                </StepperText>
                {index + 1 !== steps.length && (
                    <StepperLine stepType={stepType} completed={step.completed} data-testid="svy-stepper-line" />
                )}
            </StepperStep>
        ))}
    </Container>
);

SvyStepper.displayName = "SvyStepper";
